import type { StatusFilter } from './types';

export const PAGE_SIZES = [10, 25, 50];

export const STATUS_FILTERS: { value: StatusFilter; label: string }[] = [
  { value: 'all', label: 'All statuses' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'incomplete', label: 'Configuration incomplete' },
];

